/**
 * Convert string to number with null safety and decimal precision.
 * Returns 0 for invalid values.
 */
export const transformStringToNumber = (str?: string | number | null, decimals = 2): number => {
  if (!str || isNaN(Number(str))) return 0
  return Number(Number(str).toFixed(decimals))
}
